export const purchasesCards = {
    expenseCard: {
        entity: 'expense',
        path: 'expense',
        titleBar: { mergeParams: ['number'], new: 'purchases.expense.form.new.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                { type: 'submit', id: 'expenseCard.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary', confirm: false, invalidateQuery: 'expense' }
            ],
            menuItems: [
                { action: 'delete', label: 'all.confirm.delete.accept', confirm: true, modalConfig: 'expenseConfirmDelete' },
                { action: 'book', label: 'all.menu.item.book', confirm: true, modalConfig: 'expenseConfirmBook', invalidateQuery: 'expense' }
            ],
            actions: {
                book: { message: 'purchases.expense.action.book.message' }
            }
        },
        width: '',
        // Saving a new expense closes it: typed or applied from a receipt, the
        // next thing is usually the next receipt, not this one again.
        afterSubmit: { navigateTo: '/purchases/expense', reopenNew: false },
        fieldsLogic: ['paymentTermId', 'date', 'currency'],
        defaultData: [
            { id: 'font', defaultType: 'value', defaultValue: 'Courier' },
            { id: 'layout', defaultType: 'value', defaultValue: 'default' }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'documents',
                    title: 'purchases.expense.mobile.documents',
                    modalTitle: 'purchases.expense.mobile.documents',
                    entity: 'expense',
                    icon: 'attachment',
                    count: {
                        arrays: ['attachments'],
                        condition: { field: 'source', operator: 'equals', value: 'purchaseOrder' }
                    },
                    modalFormRef: 'expenseDocuments'
                }
            ]
        },
        sections: [
            {
                id: 'expense.header',
                // Number and date fill themselves (and a receipt's suggestion
                // fills the rest): the header opens as its display.
                meta: {
                    type: 'form',
                    onMount: 'collapse',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'purchases.expense.form.number',
                                placeholder: 'purchases.expense.form.number.placeholder',
                                entity: 'expense',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'purchases.expense.form.date',
                                placeholder: 'purchases.expense.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['exchangeRate', 'currency', 'paymentTermId', 'date', 'paymentTermDays', 'paymentDate'],
                                align: 'right'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        id: 'supplierInvoiceNumber',
                        label: 'purchases.expense.form.supplierInvoiceNumber',
                        placeholder: 'purchases.expense.form.supplierInvoiceNumber.placeholder'
                    },
                    {
                        type: 'text-readOnly',
                        id: 'purchaseOrderNumber',
                        label: 'purchases.expense.form.purchaseOrder',
                        condition: { field: 'source', operator: 'equals', value: 'purchaseOrder' }
                    },
                    {
                        type: "currency",
                        id: 'currency',
                        displayField: 'currencyName',
                        parameter: "date",
                        label: 'purchases.expense.form.currency',
                        placeholder: 'purchases.expense.form.currency.placeholder',
                        modalTitle: "purchases.expense.form.currency.modal.title",
                        entity: 'currency',
                        valueMap: {
                            'currency': 'id',
                            'currencyName': 'name',
                            'baseCurrency': 'baseCurrency'
                        },
                        options: { withHeaders: false, displayId: true },
                        required: true,
                        autoComplete: 'code-currency'
                    },
                    {
                        type: 'group',
                        id: 'paymentTermIdDate',
                        fields: [
                            {
                                type: 'select',
                                id: 'paymentTermId',
                                displayField: 'paymentTermName',
                                label: 'purchases.expense.form.paymentTerm',
                                entity: 'paymentTerm',
                                valueMap: {
                                    'paymentTermId': 'id',
                                    'paymentTermName': 'name',
                                    'paymentTermDays': 'days',
                                },
                                options: { withHeaders: false, displayId: true },
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate']
                            },
                            {
                                type: 'date',
                                id: 'paymentDate',
                                label: 'purchases.expense.form.paymentDate',
                                placeholder: 'purchases.expense.form.paymentDate.placeholder',
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate'],
                                align: 'right'
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'notes',
                        label: 'purchases.expense.form.notes',
                        placeholder: 'purchases.expense.form.notes.placeholder',
                        rows: 3
                    }
                ],
                buttons: [
                    { type: 'button', id: 'expenseCard.header.close', action: 'close', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'purchases.expense.form.number.missing.message',
                    columns: [
                        {
                            weight: 1, basis: '40%',
                            elements: [
                                { type: 'field', value: 'number', scale: 'title' },
                                { type: 'date', value: 'date', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2, basis: '60%', align: 'end',
                            elements: [
                                { type: 'field', value: 'supplierInvoiceNumber', scale: 'normal', prefix: 'purchases.expense.form.supplierInvoiceNumber.prefix', condition: { field: 'supplierInvoiceNumber', operator: 'notEmpty' } },
                                { type: 'field', value: 'purchaseOrderNumber', scale: 'normal', prefix: 'purchases.expense.form.purchaseOrder.prefix', condition: { field: 'purchaseOrderNumber', operator: 'notEmpty' } }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'expense.supplier',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'supplierId',
                        displayField: 'supplierName',
                        label: 'purchases.expense.form.supplier',
                        placeholder: 'purchases.expense.form.supplier.placeholder',
                        modalTitle: 'purchases.expense.form.supplier.modal.title',
                        entity: 'contact',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'contactType', value: 'supplier|both' }]
                        },
                        valueMap: {
                            'supplierId': 'id',
                            'supplierName': 'name',
                            'supplierEmail': 'email',
                            'supplierAddress_street': 'address_street',
                            'supplierAddress_postCode': 'address_postCode',
                            'supplierAddress_city': 'address_city',
                            'supplierAddress_region': 'address_region',
                            'supplierCountry': 'country',
                            'supplierCountryName': 'countryName',
                            'companyTypeId': 'companyTypeId'
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'email',
                        id: 'supplierEmail',
                        label: 'purchases.expense.form.supplierEmail',
                        placeholder: 'purchases.expense.form.supplierEmail.placeholder',
                    },
                    {
                        type: 'text',
                        id: 'supplierAddress_street',
                        label: 'purchases.expense.form.supplierAddress',
                        placeholder: 'purchases.expense.form.supplierAddress.street',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'supplierAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'supplierAddress_postCode',
                                placeholder: 'purchases.expense.form.supplierAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'supplierAddress_city',
                                placeholder: 'purchases.expense.form.supplierAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        id: 'supplierAddress_region',
                        placeholder: 'purchases.expense.form.supplierAddress.region',
                        autoComplete: 'address-level1'
                    },
                    {
                        type: 'country',
                        id: 'supplierCountry',
                        displayField: 'supplierCountryName',
                        placeholder: 'purchases.expense.form.supplierCountry',
                        valueMap: {
                            'supplierCountry': 'id',
                            'supplierCountryName': 'name',
                        },
                        defaultType: 'country',
                        fgMargin: '1.5rem'
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'expenseCard.supplier.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'supplierName',
                    emptyMessage: 'purchases.expense.form.supplier.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'supplierName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'supplierEmail',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['supplierAddress_street', 'supplierAddress_postCode', 'supplierAddress_city', 'supplierCountryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'expense.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'purchases.expense.form.line.add',
                    width: '1024px',
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'purchases.expense.form.line.product',
                        placeholder: 'purchases.expense.form.line.product.placeholder',
                        modalTitle: 'purchases.expense.form.line.product.modal.title',
                        entity: 'product',
                        /*
                         * The product's cost is the unit price, and shows in
                         * the N box straight away. Writing it to pricedNetAmount
                         * as well marks the net as priced, so on save the line
                         * recalculates it as cost × quantity. `clearValue` is on
                         * no product, so it always resolves to null and
                         * nullDefaults writes 0 — a gross typed before the
                         * product was picked would otherwise win over the cost.
                         */
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'itemType': 'type',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                            'unitPrice': 'unitCost',
                            'enteredNetAmount': 'unitCost',
                            'pricedNetAmount': 'unitCost',
                            'enteredGrossAmount': 'clearValue'
                        },
                        nullDefaults: { enteredGrossAmount: 0 },
                        options: { withHeaders: true },
                        required: true,
                        manualEntry: true
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'purchases.expense.form.line.description',
                        placeholder: 'purchases.expense.form.line.description.placeholder',
                        rows: 2
                    },
                    /*
                     * The expense category: one of the org's own expense
                     * accounts, grouped by GET /expenseCategory. Only an account
                     * can be picked, never its group. Left empty, the PURCHASE
                     * posting rule decides where the cost goes.
                     */
                    {
                        type: 'hconnect',
                        id: 'expenseAccountId',
                        displayField: 'expenseAccountIdName',
                        parentId: 'parentId',
                        label: 'purchases.expense.form.line.category',
                        placeholder: 'purchases.expense.form.line.category.placeholder',
                        modalTitle: 'purchases.expense.form.line.category.modal.title',
                        entity: 'expenseCategory',
                        parentField: { field: 'level', value: 'group' },
                        valueMap: {
                            'expenseAccountId': 'id',
                            'expenseAccountIdName': 'name',
                            'expenseAccountNumber': 'number'
                        },
                        options: { withHeaders: false, pickGroup: false }
                    },
                    {
                        type: 'group',
                        id: 'itemQuantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'itemQuantity',
                                label: 'purchases.expense.form.line.quantity',
                                placeholder: 'purchases.expense.form.line.quantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'purchases.expense.form.line.unit',
                                placeholder: 'purchases.expense.form.line.unit.placeholder',
                                entity: 'unit',
                                valueMap: { 'unitName': 'name', 'unitId': 'id' },
                                options: { withHeaders: true }
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'lineAmountItemTaxId',
                        focus: false,
                        fields: [
                            {
                                type: 'dualInput',
                                id: 'enteredGrossAmount',
                                secondaryId: 'enteredNetAmount',
                                label: 'purchases.expense.form.line.amount',
                                placeholder: 'purchases.expense.form.line.amount.placeholder',
                                primaryLabel: 'purchases.expense.form.line.amount.gross.short',
                                secondaryLabel: 'purchases.expense.form.line.amount.net.short',
                                decimals: 2,
                                variant: 'price'
                            },
                            {
                                type: 'select',
                                id: 'itemTaxId',
                                displayField: 'itemTaxName',
                                label: 'purchases.expense.form.line.tax',
                                entity: 'vatTax',
                                entityParams: {
                                    type: 'query',
                                    params: [
                                        { key: 'scope', value: 'purchases' },
                                        { key: 'recipientLocation', value: '${supplierCountry}' },
                                        { key: 'companyType', value: '${companyTypeId}' },
                                        { key: 'productType', value: '${itemType}' }
                                    ]
                                },
                                valueMap: {
                                    'itemTaxName': 'name',
                                    'itemTaxId': 'id',
                                    'itemTaxRate': 'rate'
                                },
                                // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                                nullDefaults: { itemTaxRate: null },
                                options: { withHeaders: false },
                                linkedFields: ['supplierCountry', 'companyTypeId'],
                                lineLinkedFields: ['itemType']
                            }
                        ]
                    }
                ],
                buttons: [
                    { type: 'button', id: 'expenseCard.lines.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                    { type: 'button', id: 'expenseCard.lines.save', action: 'save', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'purchases.expense.form.line.missing.message',
                    columns: [
                        {
                            weight: 7, basis: '70%',
                            elements: [
                                { type: 'merge', value: '${1} (x${2})', mergeParams: ['itemName', 'itemQuantity'], scale: 'title' },
                                { type: 'field', value: 'itemDescription', scale: 'normal' },
                                { type: 'merge', value: '${1} ${2}', mergeParams: ['expenseAccountNumber', 'expenseAccountIdName'], scale: 'normal', condition: { field: 'expenseAccountId', operator: 'notEmpty' } }
                            ]
                        },
                        {
                            weight: 3, basis: '30%', align: 'end',
                            elements: [
                                { type: 'amount', value: 'grossAmount', scale: 'title', decorator: 'currency' },
                                { type: 'field', value: 'itemTaxName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'expense.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1024px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    elements: [
                        { type: 'line', value: 'totalNetAmount', scale: 'normal', label: 'purchases.expense.form.subtotal', decorator: 'currency' },
                        { type: 'line', value: 'totalVatAmount', scale: 'normal', label: 'all.form.field.vat', decorator: 'currency' },
                        { type: 'line', value: 'totalGrossAmount', scale: 'large', label: 'purchases.expense.form.total', decorator: 'currency' }
                    ]
                }
            }
        ]
    },
    purchaseOrderCard: {
        entity: 'purchaseOrder',
        path: 'purchaseOrder',
        titleBar: { mergeParams: ['number'], new: 'purchases.purchaseOrder.form.new.title' },
        cardTitle: {
            title: 'purchases.purchaseOrder.form.dropdown.toggle',
            buttons: [
                { type: 'submit', id: 'purchaseOrderCard.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary', confirm: false, invalidateQuery: 'purchaseOrder' }
            ],
            menuItems: [
                { action: 'book', label: 'purchases.purchaseOrder.form.confirm', confirm: true, modalConfig: 'purchaseOrderConfirmBook', invalidateQuery: 'purchaseOrder' },
                { action: 'delete', label: 'purchases.purchaseOrder.form.delete', confirm: true, modalConfig: 'purchaseOrderConfirmDelete' }
            ],
            actions: {
                book: { message: 'purchases.purchaseOrder.action.confirm.message' }
            }
        },
        width: '',
        afterSubmit: { navigateTo: '/purchases/purchaseOrder' },
        fieldsLogic: ['paymentTermId', 'date', 'currency'],
        sections: [
            {
                id: 'purchaseOrder.header',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'purchases.purchaseOrder.form.number',
                                placeholder: 'purchases.purchaseOrder.form.number.placeholder',
                                entity: 'purchaseOrder',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'purchases.purchaseOrder.form.date',
                                placeholder: 'purchases.purchaseOrder.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['exchangeRate', 'currency', 'paymentTermId', 'date', 'paymentTermDays', 'paymentDate'],
                                align: 'right'
                            }
                        ]
                    },
                    {
                        type: 'date',
                        id: 'deliveryDate',
                        label: 'purchases.purchaseOrder.form.deliveryDate',
                        placeholder: 'purchases.purchaseOrder.form.deliveryDate.placeholder',
                        defaultType: 'date',
                    },
                    {
                        type: "currency",
                        id: 'currency',
                        displayField: 'currencyName',
                        parameter: "date",
                        label: 'purchases.purchaseOrder.form.currency',
                        placeholder: 'purchases.purchaseOrder.form.currency.placeholder',
                        modalTitle: "purchases.purchaseOrder.form.currency.modal.title",
                        entity: 'currency',
                        valueMap: {
                            'currency': 'id',
                            'currencyName': 'name',
                        },
                        options: { withHeaders: false, displayId: true },
                        required: true,
                        autoComplete: 'code-currency'
                    },
                    {
                        type: 'group',
                        id: 'paymentTermIdDate',
                        fields: [
                            {
                                type: 'select',
                                id: 'paymentTermId',
                                displayField: 'paymentTermName',
                                label: 'purchases.purchaseOrder.form.paymentTerm',
                                entity: 'paymentTerm',
                                valueMap: {
                                    'paymentTermId': 'id',
                                    'paymentTermName': 'name',
                                    'paymentTermDays': 'days',
                                },
                                options: { withHeaders: false, displayId: true },
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate']
                            },
                            {
                                type: 'date',
                                id: 'paymentDate',
                                label: 'purchases.purchaseOrder.form.paymentDate',
                                placeholder: 'purchases.purchaseOrder.form.paymentDate.placeholder',
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate'],
                                align: 'right'
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'notes',
                        label: 'purchases.purchaseOrder.form.notes',
                        placeholder: 'purchases.purchaseOrder.form.notes.placeholder',
                        rows: 3
                    }
                ],
                buttons: [
                    { type: 'button', id: 'purchaseOrderCard.header.close', action: 'close', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'purchases.purchaseOrder.form.number.missing.message',
                    columns: [
                        {
                            weight: 1, basis: '40%',
                            elements: [
                                { type: 'field', value: 'number', scale: 'title' },
                                { type: 'date', value: 'date', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2, basis: '60%',
                            elements: [
                                { type: 'field', value: 'state', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'purchaseOrder.supplier',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'supplierId',
                        displayField: 'supplierName',
                        label: 'purchases.purchaseOrder.form.supplier',
                        placeholder: 'purchases.purchaseOrder.form.supplier.placeholder',
                        modalTitle: 'purchases.purchaseOrder.form.supplier.modal.title',
                        entity: 'contact',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'contactType', value: 'supplier|both' }]
                        },
                        valueMap: {
                            'supplierId': 'id',
                            'supplierName': 'name',
                            'supplierEmail': 'email',
                            'supplierAddress_street': 'address_street',
                            'supplierAddress_postCode': 'address_postCode',
                            'supplierAddress_city': 'address_city',
                            'supplierAddress_region': 'address_region',
                            'supplierCountry': 'country',
                            'supplierCountryName': 'countryName',
                            'companyTypeId': 'companyTypeId'
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'email',
                        id: 'supplierEmail',
                        label: 'purchases.purchaseOrder.form.supplierEmail',
                        placeholder: 'purchases.purchaseOrder.form.supplierEmail.placeholder',
                    },
                    {
                        type: 'text',
                        id: 'supplierAddress_street',
                        label: 'purchases.purchaseOrder.form.supplierAddress',
                        placeholder: 'purchases.purchaseOrder.form.supplierAddress.street',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'supplierAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'supplierAddress_postCode',
                                placeholder: 'purchases.purchaseOrder.form.supplierAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'supplierAddress_city',
                                placeholder: 'purchases.purchaseOrder.form.supplierAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        id: 'supplierAddress_region',
                        placeholder: 'purchases.purchaseOrder.form.supplierAddress.region',
                        autoComplete: 'address-level1'
                    },
                    {
                        type: 'country',
                        id: 'supplierCountry',
                        displayField: 'supplierCountryName',
                        placeholder: 'purchases.purchaseOrder.form.supplierCountry',
                        valueMap: {
                            'supplierCountry': 'id',
                            'supplierCountryName': 'name',
                        },
                        defaultType: 'country',
                        fgMargin: '1.5rem'
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'purchaseOrderCard.supplier.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'supplierName',
                    emptyMessage: 'purchases.purchaseOrder.form.supplier.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'supplierName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'supplierEmail',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['supplierAddress_street', 'supplierAddress_postCode', 'supplierAddress_city', 'supplierCountryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'purchaseOrder.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'purchases.purchaseOrder.form.line.add',
                    width: '1200px',
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'purchases.purchaseOrder.form.line.product',
                        placeholder: 'purchases.purchaseOrder.form.line.product.placeholder',
                        modalTitle: 'purchases.purchaseOrder.form.line.product.modal.title',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'itemType': 'type',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                            'unitPrice': 'unitCost'
                        },
                        options: { withHeaders: true }
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'purchases.purchaseOrder.form.line.description',
                        placeholder: 'purchases.purchaseOrder.form.line.description.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'quantityOrderedUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'quantityOrdered',
                                label: 'purchases.purchaseOrder.form.line.quantity',
                                placeholder: 'purchases.purchaseOrder.form.line.quantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'purchases.purchaseOrder.form.line.unit',
                                placeholder: 'purchases.purchaseOrder.form.line.unit.placeholder',
                                entity: 'unit',
                                valueMap: { 'unitName': 'name', 'unitId': 'id' },
                                options: { withHeaders: true }
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'unitPriceItemTaxId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'unitPrice',
                                label: 'purchases.purchaseOrder.form.line.unitPrice',
                                placeholder: 'purchases.purchaseOrder.form.line.unitPrice',
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 0,
                                variant: 'price'
                            },
                            {
                                type: 'select',
                                id: 'itemTaxId',
                                displayField: 'itemTaxName',
                                label: 'purchases.purchaseOrder.form.line.tax',
                                entity: 'vatTax',
                                entityParams: {
                                    type: 'query',
                                    params: [
                                        { key: 'scope', value: 'purchases' },
                                        { key: 'recipientLocation', value: '${supplierCountry}' },
                                        { key: 'companyType', value: '${companyTypeId}' },
                                        { key: 'productType', value: '${itemType}' }
                                    ]
                                },
                                valueMap: {
                                    'itemTaxName': 'name',
                                    'itemTaxId': 'id',
                                    'itemTaxRate': 'rate'
                                },
                                // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                                nullDefaults: { itemTaxRate: null },
                                options: { withHeaders: false },
                                linkedFields: ['supplierCountry', 'companyTypeId'],
                                lineLinkedFields: ['itemType']
                            }
                        ]
                    }
                ],
                buttons: [
                    { type: 'button', id: 'purchaseOrderCard.lines.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                    { type: 'button', id: 'purchaseOrderCard.lines.save', action: 'save', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'purchases.purchaseOrder.form.line.missing.message',
                    columns: [
                        {
                            weight: 7, basis: '70%',
                            elements: [
                                { type: 'merge', value: '${1} (x${2})', mergeParams: ['itemName', 'quantityOrdered'], scale: 'title' },
                                { type: 'field', value: 'itemDescription', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 3, basis: '30%', align: 'end',
                            elements: [
                                { type: 'amount', value: 'unitPrice', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'purchaseOrder.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1200px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetAmount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalVatAmount',
                            scale: 'normal',
                            label: 'all.form.field.vat',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            }
        ]
    },

    purchaseRequestDraftCard: {
        entity: 'purchaseRequest',
        path: 'purchaseRequest',
        endpoint: 'purchaseRequest',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'purchases.purchaseRequest.form.dropdown.toggle',
            buttons: [
                { type: 'submit', id: 'purchaseRequestDraftCard.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary', invalidateQuery: 'purchaseRequest' }
            ],
            menuItems: [
                { action: 'submit', label: 'purchases.purchaseRequest.form.submit', confirm: true, modalConfig: 'purchaseRequestConfirmSubmit' },
                { action: 'delete', label: 'all.form.button.delete', confirm: true, modalConfig: 'purchaseRequestConfirmDelete' }
            ],
            actions: {
                submit: { message: 'purchases.purchaseRequest.action.submit.message' }
            }
        },
        sections: [
            {
                id: 'purchaseRequest.header',
                meta: { type: 'form', width: '800px' },
                groups: [
                    {
                        type: 'group',
                        id: 'numberRequestedAt',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'purchases.purchaseRequest.form.number',
                                placeholder: 'purchases.purchaseRequest.form.number.placeholder',
                                entity: 'purchaseRequest',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'requestedAt',
                                label: 'purchases.purchaseRequest.form.requestedAt',
                                defaultType: 'date',
                                align: 'right'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'neededDateWarehouseId',
                        fields: [
                            {
                                type: 'date',
                                id: 'neededDate',
                                label: 'purchases.purchaseRequest.form.neededDate',
                                defaultType: 'date'
                            },
                            {
                                type: 'connect',
                                id: 'warehouseId',
                                displayField: 'warehouseName',
                                label: 'purchases.purchaseRequest.form.warehouse',
                                placeholder: 'purchases.purchaseRequest.form.warehouse.placeholder',
                                modalTitle: 'purchases.purchaseRequest.form.warehouse.modal.title',
                                entity: 'warehouse',
                                valueMap: { warehouseId: 'id', warehouseName: 'name' },
                                options: { withHeaders: true }
                            }]
                    },
                    {
                        type: 'connect',
                        id: 'requestedById',
                        displayField: 'requestedBy',
                        label: 'purchases.purchaseRequest.form.requestedBy',
                        placeholder: 'purchases.purchaseRequest.form.requestedBy.placeholder',
                        modalTitle: 'purchases.purchaseRequest.form.requestedBy.modal.title',
                        entity: 'employee',
                        valueMap: { requestedById: 'id', requestedBy: 'name' },
                        options: { withHeaders: true }
                    },
                    {
                        type: 'textarea',
                        id: 'notes',
                        label: 'purchases.purchaseRequest.form.notes',
                        placeholder: 'purchases.purchaseRequest.form.notes.placeholder'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'purchases.purchaseRequest.form.number.missing.message',
                    columns: [
                        {
                            weight: 1, basis: '100%',
                            elements: [
                                { type: 'field', value: 'number', scale: 'title' },
                                { type: 'field', value: 'warehouseName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'purchaseRequest.lines',
                meta: { type: 'grid', gridConfig: 'purchaseRequestLinesGrid' }
            },
            {
                id: 'purchaseRequest.totals',
                meta: { type: 'form', collapsible: false, width: '800px' },
                groups: [
                    {
                        type: 'group',
                        id: 'linesEstimatedAmount',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'lines',
                                subObject: 'totals',
                                label: 'purchases.purchaseRequest.form.totals.lines'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'estimatedAmount',
                                subObject: 'totals',
                                label: 'purchases.purchaseRequest.form.totals.estimatedAmount',
                                displayType: 'amount'
                            }
                        ]
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    columns: [
                        {
                            weight: 1, basis: '50%',
                            elements: [
                                { type: 'merge', value: 'purchaseRequest.form.totals.lines', scale: 'title' },
                                { type: 'field', value: 'totals.lines', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1, basis: '50%', align: 'end',
                            elements: [
                                { type: 'text', value: 'purchaseRequest.form.totals.amount', scale: 'title' },
                                { type: 'amount', value: 'totals.estimatedAmount', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    purchaseRequestSubmittedCard: {
        entity: 'purchaseRequest',
        path: 'purchaseRequest',
        endpoint: 'purchaseRequest',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'purchases.purchaseRequest.form.dropdown.toggle',
            buttons: [
                { type: 'submit', id: 'purchaseRequestSubmittedCard.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary', invalidateQuery: 'purchaseRequest' }
            ],
            menuItems: [
                { action: 'generatePurchaseOrders', label: 'purchases.purchaseRequest.form.generatePOs', confirm: true, modalConfig: 'purchaseRequestConfirmGeneratePOs' },
                { action: 'sourceLines', label: 'purchases.purchaseRequest.form.sourceLines' },
                { action: 'archive', label: 'all.menu.item.archive' }
            ]
        },
        sections: [
            {
                id: 'purchaseRequest.header',
                meta: { type: 'form', width: '800px' },
                groups: [
                    {
                        type: 'text-readOnly',
                        id: 'number',
                        label: 'purchases.purchaseRequest.form.number'
                    },
                    {
                        type: 'stateBadge',
                        id: 'state',
                        label: 'purchases.purchaseRequest.form.state',
                        states: { draft: 'disabled', submitted: 'info' }
                    },
                    {
                        type: 'group',
                        id: 'requestedAtNeededDate',
                        mobileRow: true,
                        fields: [
                            {
                                type: 'date',
                                id: 'requestedAt',
                                label: 'purchases.purchaseRequest.form.requestedAt'
                            },
                            {
                                type: 'date',
                                id: 'neededDate',
                                label: 'purchases.purchaseRequest.form.neededDate'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'warehouseNameRequestedBy',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'warehouseName',
                                label: 'purchases.purchaseRequest.form.warehouse'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'requestedBy',
                                label: 'purchases.purchaseRequest.form.requestedBy'
                            }]
                    },
                    {
                        type: 'text-readOnly',
                        id: 'notes',
                        label: 'purchases.purchaseRequest.form.notes'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    columns: [
                        {
                            weight: 1, basis: '100%',
                            elements: [
                                { type: 'field', value: 'number', scale: 'title' },
                                { type: 'field', value: 'warehouseName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'purchaseRequest.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    showAddLine: false,
                    width: '800px',
                },
                groups: [
                    {
                        type: 'text-readOnly',
                        id: 'itemName',
                        label: 'purchases.purchaseRequest.form.line.product'
                    },
                    {
                        type: 'group',
                        id: 'requestedQtyUnitName',
                        mobileRow: true,
                        fields: [
                            {
                                type: 'number',
                                id: 'requestedQty',
                                label: 'purchases.purchaseRequest.form.line.requestedQty'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'unitName',
                                label: 'purchases.purchaseRequest.form.line.unit'
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'supplierId',
                        displayField: 'supplierName',
                        label: 'purchases.purchaseRequest.form.line.supplier',
                        placeholder: 'purchases.purchaseRequest.form.line.supplier.placeholder',
                        modalTitle: 'purchases.purchaseRequest.form.line.supplier.modal.title',
                        entity: 'contact',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'contactType', value: 'supplier|both' }]
                        },
                        valueMap: {
                            'supplierId': 'id',
                            'supplierName': 'name',
                            'supplierAddress_street': 'address_street',
                            'supplierAddress_postCode': 'address_postCode',
                            'supplierAddress_city': 'address_city',
                            'supplierCountry': 'country',
                            'supplierCountryName': 'countryName'
                        },
                        options: { withHeaders: true }
                    },
                    {
                        type: 'group',
                        id: 'supplierUnitPriceCurrency',
                        mobileRow: true,
                        fields: [

                            {
                                type: 'number',
                                id: 'supplierUnitPrice',
                                label: 'purchases.purchaseRequest.form.line.sourcing.unitPrice',
                                decimals: 4
                            },
                            {
                                type: 'connect',
                                id: 'currency',
                                displayField: 'currencyName',
                                label: 'purchases.purchaseRequest.form.line.sourcing.currency',
                                entity: 'currency',
                                valueMap: { currency: 'id', currencyName: 'name' }
                            }]
                    },
                    {
                        type: 'group',
                        id: 'leadTimeDaysSourcingNeededDate',
                        mobileRow: true,
                        fields: [
                            {
                                type: 'number',
                                id: 'leadTimeDays',
                                label: 'purchases.purchaseRequest.form.line.sourcing.leadTimeDays'
                            },
                            {
                                type: 'date',
                                id: 'sourcingNeededDate',
                                label: 'purchases.purchaseRequest.form.line.sourcing.neededDate'
                            }]
                    },
                    {
                        type: 'text',
                        id: 'note',
                        label: 'purchases.purchaseRequest.form.line.note'
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'purchaseRequestSubmittedCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'purchases.purchaseRequest.form.lines.empty',
                    editButtonRightOffset: '30%',
                    columns: [
                        {
                            weight: 7,
                            basis: '60%',
                            margin: '0 0 0 0.5rem ',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'requestedQty'],
                                    scale: 'title'
                                },
                                { type: 'field', value: 'supplierName', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '40%',
                            align: 'end',
                            elements: [
                                { type: 'amount', value: 'supplierUnitPrice', scale: 'title' },
                                { type: 'field', value: 'currencyName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'purchaseRequest.totals',
                meta: { type: 'form', collapsible: true, width: '800px' },
                groups: [
                    {
                        type: 'group',
                        id: 'linesEstimatedAmountOrderedLines',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'lines',
                                subObject: 'totals',
                                label: 'purchases.purchaseRequest.form.totals.lines'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'estimatedAmount',
                                subObject: 'totals',
                                label: 'purchases.purchaseRequest.form.totals.estimatedAmount',
                                displayType: 'amount'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'orderedLines',
                                subObject: 'totals',
                                label: 'purchases.purchaseRequest.form.totals.orderedLines'
                            }
                        ]
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    columns: [
                        {
                            weight: 1, basis: '15%', align: 'end',
                            elements: [
                                { type: 'merge', value: 'purchaseRequest.form.totals.toOrder', scale: 'title' },
                                { type: 'amount', value: 'totals.quantity', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1, basis: '20%', align: 'end',
                            elements: [
                                { type: 'text', value: 'purchaseRequest.form.totals.sourcedQuantity', scale: 'title' },
                                { type: 'amount', value: 'totals.sourcedQuantity', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1, basis: '20%', align: 'end',
                            elements: [
                                { type: 'text', value: 'purchaseRequest.form.totals.orderQuantity', scale: 'title' },
                                { type: 'amount', value: 'totals.orderedQuantity', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 3, basis: '45%', align: 'end',
                            elements: [
                                { type: 'text', value: 'purchaseRequest.form.totals.amount', scale: 'title' },
                                { type: 'amount', value: 'totals.estimatedAmount', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    purchasesSettingsCard: {
        entity: 'purchasesSettings',
        path: 'purchasesSettings',
        titleBar: { label: 'purchases.settings.heading', mergeParams: ['settingsType'], new: 'purchases.settings.title' },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [
            {
                id: 'purchasesSettings.defaults',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'defaultValues',
                        label: 'purchases.settings.defaults.title',
                        text: 'purchases.settings.defaults.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'currency',
                        id: 'defaultCurrency',
                        displayField: 'defaultCurrencyName',
                        label: 'purchases.settings.defaultCurrency',
                        entity: 'currency',
                        valueMap: { 'defaultCurrency': 'id', 'defaultCurrencyName': 'name' },
                    },
                    {
                        type: 'select',
                        id: 'defaultUnitId',
                        displayField: 'defaultUnitName',
                        label: 'purchases.settings.defaultUnit',
                        placeholder: 'purchases.settings.defaultUnit.placeholder',
                        entity: 'unit',
                        valueMap: { 'defaultUnitName': 'name', 'defaultUnitId': 'id' },
                        options: { withHeaders: true }
                    }
                ],
                buttons: [
                    { type: 'submit', id: 'purchasesSettingsCard.defaults.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'defaultCurrency',
                    emptyMessage: 'purchases.settings.form.empty.message',
                    columns: [
                        {
                            weight: 1, basis: '100%',
                            elements: [
                                { type: 'text', value: 'Purchases Settings', scale: 'title' }
                            ]
                        }
                    ]
                }
            },
            // The module's number series (37.03) — see salesSettingsCard.
            {
                id: 'purchasesSettings.numberSeries',
                meta: {
                    type: 'lines',
                    linesArray: 'numberSeries',
                    showAddLine: false,
                    sectionTitle: 'settings.numberSeries.title',
                    width: '756px'
                },
                groups: [
                    { type: 'text-readOnly', id: 'format', label: 'settings.numberSeries.format' },
                    { type: 'text-readOnly', id: 'lastValue', label: 'settings.numberSeries.lastValue' },
                    { type: 'nserie', id: 'nextValue', label: 'settings.numberSeries.nextValue', placeholder: 'settings.numberSeries.nextValue.placeholder', required: true }
                ],
                buttons: [
                    { type: 'submit', id: 'purchasesSettingsCard.numberSeries.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'nextValue',
                    emptyMessage: 'settings.numberSeries.empty',
                    columns: [
                        {
                            weight: 6, basis: '60%',
                            elements: [
                                { type: 'merge', value: '${1}', mergeParams: [{ type: 'translate', value: 'labelKey' }], scale: 'title' },
                                { type: 'field', value: 'format', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 4, basis: '40%', align: 'end',
                            elements: [
                                { type: 'field', value: 'nextValue', scale: 'title', prefix: 'settings.numberSeries.next.prefix' },
                                { type: 'field', value: 'lastValue', scale: 'normal', prefix: 'settings.numberSeries.last.prefix', condition: { field: 'lastValue', operator: 'notEmpty' } }
                            ]
                        }
                    ]
                }
            }
        ]
    },
}
